import axios from 'axios'
import { CommonPortionTypeResponse } from '@/api/services/common/portion-type/common-portion-type.dto'

class CommonPortionTypeService {
    async getPortionTypes(): Promise<CommonPortionTypeResponse[]> {
        const response = await axios.get<CommonPortionTypeResponse[]>(`/portionTypes/`)
        return response.data
    }

    async getPhysicalPortionTypes(): Promise<CommonPortionTypeResponse[]> {
        const response = await axios.get<CommonPortionTypeResponse[]>(`/portionTypes/physicalPortionTypes`)
        return response.data
    }
}

export const commonPortionTypeService = new CommonPortionTypeService()
